import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { NotFound } from './site/Guides.tsx';
import { pageFor } from './site/pages.tsx';
import { Account } from './site/Site.tsx';
import './site/site.css'; // first, as when Site.tsx imported it: styles.css wins ties
import './styles.css';
import './editors.css';

// The jam itself (audio engine, editors) loads only on /host and /j/CODE, so the public
// pages stay light for phones and search engines.
const ClientApp = lazy(() => import('./client/ClientApp.tsx').then((m) => ({ default: m.ClientApp })));
const HostApp = lazy(() => import('./host/HostApp.tsx').then((m) => ({ default: m.HostApp })));

function Router() {
  const path = location.pathname.replace(/\/+$/, '') || '/';
  const join = path.match(/^\/j\/([A-Za-z]{4})$/);
  if (join) return <ClientApp code={join[1].toUpperCase()} />;
  if (path.startsWith('/host')) return <HostApp />;
  if (path === '/account') return <Account />;
  const page = pageFor(path);
  return page ? <page.Component /> : <NotFound />;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={null}>
      <Router />
    </Suspense>
  </StrictMode>,
);
